var _defs, _g, _image, _rect, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIpRdp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-10 -10 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-18 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-17);\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-3 {\n        fill: #57825f;\n      }\n\n      .cls-22 {\n        isolation: isolate;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 41.9,
    cy: 42,
    r: 33.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.4,
    y: 23.5,
    width: 38,
    height: 38
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31,28.6h-6.3v-3.8h6.3v3.8ZM31.6,23.5h-7.6c-.3,0-.6.3-.6.6v5.1c0,.2,0,.3.2.4.1.1.3.2.4.2h3.2v1.3h-1.3v1.3h3.8v-1.3h-1.3v-1.3h3.2c.2,0,.3,0,.4-.2.1-.1.2-.3.2-.4v-5.1c0-.2,0-.3-.2-.4-.1-.1-.3-.2-.4-.2h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.7,
    y: 9.5,
    width: 67,
    height: 66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 27.2,
    y: 33.7,
    width: 1.3,
    height: 17.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 34.2,
    y: 57.1,
    width: 12.7,
    height: 1.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.3,
    y: 34.3,
    width: 1.3,
    height: 12.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 34.2,
    y: 26.7,
    width: 16.5,
    height: 1.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.1,57.7h-10.1v-7.6h10.1v7.6ZM60.8,48.9h-11.4c-.3,0-.6.3-.6.6v8.9c0,.2,0,.3.2.4.1.1.3.2.4.2h5.1v1.3h-2.5s0,1.3,0,1.3h6.3v-1.3h-2.5v-1.3h5.1c.2,0,.3,0,.4-.2.1-.1.2-.3.2-.4v-8.9c0-.2,0-.3-.2-.4-.1-.1-.3-.2-.4-.2h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.7,
    y: 9.5,
    width: 67,
    height: 66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31,57.7h-6.3v-3.8h6.3v3.8ZM31.6,52.7h-7.6c-.3,0-.6.3-.6.6v5.1h0c0,.2,0,.3.2.4.1.1.3.2.4.2h3.2v1.3h-1.3s0,1.3,0,1.3h3.8v-1.3h-1.3v-1.3h3.2c.2,0,.3,0,.4-.2.1-.1.2-.3.2-.4v-5.1c0-.2,0-.3-.2-.4-.1-.1-.3-.2-.4-.2h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.7,
    y: 9.5,
    width: 67,
    height: 66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.1,28.6h-6.3v-3.8h6.3v3.8ZM60.8,23.5h-7.6c-.3,0-.6.3-.6.6v5.1c0,.2,0,.3.2.4.1.1.3.2.4.2h3.2v1.3h-1.3v1.3h3.8v-1.3h-1.3v-1.3h3.2c.2,0,.3,0,.4-.2s.2-.3.2-.4v-5.1c0-.2,0-.3-.2-.4-.1-.1-.3-.2-.4-.2h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.7,
    y: 9.5,
    width: 67,
    height: 66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "53.7 56.2 55.1 54.8 56.4 56.2 57.3 55.3 56 53.9 57.3 52.6 56.4 51.7 55.1 53 53.7 51.7 52.8 52.6 54.2 53.9 52.8 55.3 53.7 56.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.7,
    y: 9.5,
    width: 67,
    height: 66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.2,46c.2-.3.2-.6,0-.9l-3.6-3.6.9-.9,3.6,3.6c.2.2.6.2.9,0l.2,1.9-1.9-.2ZM46.6,42.3c-.2,0-.5,0-.7.2l-.4.4-3.6-3.6c-.2-.2-.6-.2-.9,0l-1.8,1.8c-.2.2-.2.6,0,.9l3.6,3.6-.4.4c-.2.2-.2.4-.1.7,0,.2.3.4.5.4l4,.4h0c.2,0,.4,0,.5-.2.1-.1.2-.3.2-.5l-.4-4h0c0-.2-.2-.4-.4-.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.7,
    y: 9.5,
    width: 67,
    height: 66
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 7.4,
    y: 7.5,
    width: 69,
    height: 69
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 67,
    height: 66,
    transform: "translate(8.7 9.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABDCAYAAAAlFqMKAAAACXBIWXMAAAsSAAALEgHS3X78AAAEeklEQVR4nO1c0Y7kIAyD1f7/L3NPHTHUie1A5+aki7SaFmgS3BCStN3eDBpjdGc8ot77+GaZVNgJhULhQNEn5UUy3/qjjqcV+5uUgQInXQAjG28tkU/KQcDcBIhg/AvWIwG0gvI2MQJG1KeCs2MpuzJyvzGB8vu6wgNDBWckfWhMNi4aE8lA7fSm/LIBLQeDKY/6HQCqy3c0AwTILLCQaPKqxbzYO0ol5DrVAfqgLtey6a2ly6Uvv+qxqigjdpMifgiAFJQLkGzJZMogoND5ENqYn6lYY5/49qTtRo4PYb+OstdxdA0DYQW0g+NVhmSVESCRAuhXdYqZ4uxa1/FGTpUCE/kQBYAVDNXhMQdXdd6rrxik7Sa/9z4qS+Y6Zv5kFoosg1mJ47xnHzH/Xn0r39BKKk41AyNzoKpjY9a6HiO/sfKWfciPoFDUtvapcUxmacrSRWMya3KcPgQkokyRVWHUt47LeKOxaKIZHzp5RA4gkRDFQkrKiTocleECckKwMgHVYR+nCiBV+tikdggBknnjdR9n4yvjXOCOJI5XLuNYCBO8k8SdoCOylMDsEoZijNbuAZHCyyW1vrFGobY1n/AhKL1e+5+0lDQcd+VngCgTZHfAvUM7jpcWgRRdflpr7OGNIgiZqgJGNZGLeG4v2R2nyjLJRtovYhFnRbeojdILEOP5J7v7o8VWopCaSx1z4PPcmYVkDhM5s13nyRI3hbZ0cHcZxTSrCmVZKht/jJ4K3V1rYVmqkt1mbSnNFUM1MKuSUgDKKJtwqQDE6JPJXWteEUldMrtb9xs9aSGOD3AKR63htGFun/uQXF5TFR92K2vWdYbsTmf8UFF57mN6vMaMMbpSdVdAUsej/mqVbe6LEksXoNZabclEtdRMGYUnOj+V28x8U2B+W6PLZWaGzquFXdXBovOxtEXn6/XUStz3Q6IJK8orY5XzuQ09k4mukbZp90HV1e4slVMRJfIJaJfZiklOxCFPVsad3W0dX9JHdarOei959yIpZUV0TTjefXK3s94j+mRVjfJSn+1m/SeXjAKOa3GWXp/OZWZipUm3dKnIofQJQLIqOJp0VEVnJcyKPrdr3UgV7fNZPpEpg3iibTNzgqiue/2WnDkCJJpYlEBlQVjUjoK1FdgVlIh/BEpGPNsVGGRgqBGi4wuy9B3xVf4oZYBkloIUVkx7PZ4JWcd1HNU8Zp5H4h3FQpCSazsLl3d3A5U/sw56Yyrpv+IEQ4FJ+8xzHqs47HXS5ZsTAYLuPrMGxfFlSqGlohDbaSRnq7zrPgt0wYmUjtoykNcJRbtatvXKO9GLefI2c3TsFIZch6cUiiKrU0C46fP2eUhrEJBMsWqVTAFGSRgZ7wyEEIybsM2PiJ6iCiDzOd1ZXECQUm6av7NkXIoAoGBAwYUvMyvKZ8GZIzvipexq8BWQSnL3ZEVs5aXkSazf0g+ibnzZ/Sk/UiEp7ri1h9y+59v/07uY/+3/m4TvAWablNfG7MlWAVLfYTt9A9z/V/L1d78CkAvCf0roD+ui3NSV03ORAAAAAElFTkSuQmCC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.7,
    y: 9.5,
    width: 67,
    height: 66
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 22.4,
    y: 22.5,
    width: 10.9,
    height: 10.9
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 26.2,
    y: 32.7,
    width: 3.3,
    height: 19.1
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 33.2,
    y: 56.1,
    width: 14.7,
    height: 3.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 55.3,
    y: 33.3,
    width: 3.3,
    height: 14.7
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 33.2,
    y: 25.7,
    width: 18.5,
    height: 3.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 47.7,
    y: 47.9,
    width: 14.7,
    height: 14.7
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 22.4,
    y: 51.7,
    width: 10.9,
    height: 10.9
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 51.5,
    y: 22.5,
    width: 10.9,
    height: 10.9
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 51.8,
    y: 50.7,
    width: 6.5,
    height: 6.5
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 38,
    y: 38.1,
    width: 10.5,
    height: 10.5
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpRdp);
export default __webpack_public_path__ + "static/media/ip-rdp.0e31b55f9ba23dad8804f2e3981a45d9.svg";
export { ForwardRef as ReactComponent };